import { h, Component } from 'preact'
import getWithInMemoryCache from '../../utils/getWithInMemoryCache'
import globals from '../../utils/globals'
import { SEARCH_TOKEN_URL } from '../../libs/config'
import {InstantSearch, Configure, Index} from 'react-instantsearch-dom'
import CustomSearchBox from './SearchBox'
import algoliasearch from 'algoliasearch/lite'
import SearchResults from './SearchResults'
import CustomHierarchicalMenu from './filters/HierarchicalMenu'
import TagsList from './filters/Tags'

interface State {
  clientId: string,
  token: string,
  enableLoader: boolean,
  pageCount: number
}

interface Props {
  defaultCdn: string,
  attachmentCdn: string,
  isGuest: boolean,
  isFederatedSearch: boolean
}

class InstantSearchComponent extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      clientId: '',
      token: '',
      enableLoader: false,
      pageCount: 0
    }
  }

  communityId = globals('communityId') as string

  async componentDidMount () {
    const response = await getWithInMemoryCache(SEARCH_TOKEN_URL, {})
    this.setState({
      clientId: response['client_id'],
      token: response.token
    })
  }

  render ({ defaultCdn, attachmentCdn, isGuest, isFederatedSearch }: Props, { clientId, token, enableLoader, pageCount }: State) {
    if (!clientId || !token) return null

    return (
      <div className='instant-search-wrapper'>
        <InstantSearch
          searchClient={algoliasearch(clientId, token)}
          indexName={this.communityId}
        >
          <Index indexName={this.communityId}>
            <Configure
              hitsPerPage={isFederatedSearch ? 20 : 25}
              facetingAfterDistinct={true}
              page={pageCount}
              restrictSearchableAttributes={['title', 'first_post', 'answer', 'reply', 'tags', 'forum_title', 'category_title']}
              analyticsTags={['destination', 'instant-search']}
            />
          </Index>
          {
            isFederatedSearch ? (
              <Index indexName={`${this.communityId}-zendesk`}>
                <Configure
                  hitsPerPage={5}
                  page={pageCount}
                  analyticsTags={['destination', 'instant-search']}
                />
              </Index>
            ) : null
          }
          <div className='instant-search-input-wrapper'>
            <CustomSearchBox
              defaultCdn={defaultCdn}
              enableLoader={enableLoader}
              resetPagination={() => this.setState({ pageCount: 0 })}
              loaderCallback={() => this.setState({ enableLoader: true })}
            />
          </div>
          <div class='instant-search__results-wrapper'>
            <div class='instant-search__sidebar'>
              <CustomHierarchicalMenu
                title='Community Category'
                attributes={[
                  'categories.lvl0',
                  'categories.lvl1'
                ]}
              />

              <TagsList
                title='Tags'
                operator='and'
                attribute='tags'
                searchable
                limit={10}
              />
            </div>

            <SearchResults
              isGuest={isGuest}
              communityId={this.communityId}
              attachmentCdn={attachmentCdn}
              defaultCdn={defaultCdn}
              enableLoader={enableLoader}
              isFederatedSearch={isFederatedSearch}
              pageCount={pageCount}
              updatePagination={() => this.setState({ pageCount: pageCount + 1 })}
              loaderCallback={(enableLoader: boolean) => this.setState({ enableLoader: enableLoader })}
            />
          </div>

        </InstantSearch>
      </div>
    )
  }
}

export default InstantSearchComponent
